import React from "react";
import styled from "@emotion/styled";
import { breakpointMobileExtended } from "src/design-system/styles/breakpoints";

const Container = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  width: 53%;

  @media ${breakpointMobileExtended} {
    flex-direction: row;
    margin-left: 0;
    width: 100%;
  }
`;
const Inner = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: auto;

  @media ${breakpointMobileExtended} {
    margin: 15px 25px 0 25px;
  }
`;

export function Splash({ children }: { children: React.ReactNode }) {
  return (
    <Container>
      <Inner>{children}</Inner>
    </Container>
  );
}
